module.exports = __webpack_public_path__ + "static/img/jp_pz_icon01.e5b7748.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/jp_pz_icon01.png
// module id = pXaX
// module chunks = 6